import { render, staticRenderFns } from "./claustro-asociar-alumnos.vue?vue&type=template&id=60dcbe7e&"
import script from "./claustro-asociar-alumnos.component.ts?vue&type=script&lang=ts&"
export * from "./claustro-asociar-alumnos.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports